import clsx from 'clsx';

export type BadgeKind = 'ehr' | 'cerbo' | 'csv' | 'default';

const STYLES: Record<BadgeKind, string> = {
  ehr: 'bg-accent-blue/10 text-accent-blue border-accent-blue/30',
  cerbo: 'bg-accent-green/10 text-accent-green border-accent-green/30',
  csv: 'bg-accent-orange/10 text-accent-orange border-accent-orange/30',
  default: 'bg-bg-tertiary text-text-secondary border-border',
};

export function Badge({
  kind = 'default',
  children,
}: {
  kind?: BadgeKind;
  children: React.ReactNode;
}) {
  return (
    <span
      className={clsx(
        'inline-flex items-center rounded border px-2 py-0.5 font-medium',
        'text-xs uppercase tracking-wide',
        STYLES[kind],
      )}
    >
      {children}
    </span>
  );
}
